import React, { useState } from "react";
import {
  ButtonEnter,
  Container,
  Content,
  Icon,
  InputContainer,
  LinhaVertical,
  SelectDrop,
  Space,
  TitleButtonEnter,
  TitleInput,
  Title,
  DivImg,
  Img,
  ButtonImg,
} from "./style";
import { useTranslation } from "react-i18next";
import { FaRegAddressCard } from "react-icons/fa6";
import { BeatLoader } from "react-spinners";
import { MdOutlineEmail } from "react-icons/md";
import { RiLockPasswordLine } from "react-icons/ri";
import { CiPhone } from "react-icons/ci";
import { HiOutlineUserCircle } from "react-icons/hi2";
import { MdCorporateFare } from "react-icons/md";
import { FaWpforms } from "react-icons/fa";

import InputWithIcon from "../../../components/input/input";
import logo from "../../../assets/images/Logo_Ecolife_onda__1_-removebg-preview.png";

import {
  Formik,
  Field,
  Form,
  FieldInputProps,
  ErrorMessage,
  FormikHelpers,
} from "formik";
import { ToastContainer } from "react-toastify";

import Select from "react-select";
import ButtonSelect from "../../../components/button-select/ButtonSelect";
import { ErrorText, MarginBottom } from "../../login/login-seller/style";
import { useAuth } from "../../../context/AuthContext";
import { Center } from "@chakra-ui/react";
import { SelectContainer } from "../register-buy/style";
import registerValidationSellerPF from "../../../utils/validation/registerValidationSellerPF";
import registerValidationSellerPJ from "../../../utils/validation/registerValidationSellerPJ";
import MaskedInput from "../../../components/input/inputMask";
import { useNavigate } from "react-router-dom";

const options = [
  { value: "chocolate", label: "Chocolate" },
  { value: "strawberry", label: "Strawberry" },
  { value: "vanilla", label: "Vanilla" },
];

export default function RegisterSeller() {
  const navigate = useNavigate();
  const [selectedOption, setSelectedOption] = useState<number>(1);
  const [isLoading, setIsLoading] = useState(false);
  const { registerSeller, registerError } = useAuth();
  const { t } = useTranslation();
  const handleSelectChange = (option: number) => {
    setSelectedOption(option);
  };

  const initialValues = {
    type: selectedOption,
    business_name: "",
    corporate_name: "",
    document: "",
    cnpj: "",
    state_registration: "",
    phone: "",
    email: "",
    password: "",
    confirm_password: "",
  };

  const handleSubmit = async (
    values: typeof initialValues,
    actions: FormikHelpers<typeof initialValues>
  ) => {
    try {
      const data = {
        type: values.type,
        business_name: values.business_name,
        corporate_name: values.corporate_name,
        document: values.document.replace(/[^0-9]/g, ""),
        cnpj: values.cnpj.replace(/[^0-9]/g, ""),
        state_registration: values.state_registration,
        phone: values.phone.replace(/[^0-9]/g, ""),
        email: values.email,
        password: values.password,
        confirm_password: values.confirm_password,
      };
      setIsLoading(true);
      registerSeller(data);
      setIsLoading(false);
    } catch (error) {
      console.error("Erro ao cadastrar:", (error as Error).message);
    }
  };

  return (
    <Container>
      <Content>
        <Space onClick={() => navigate("/")}>
          <DivImg>
            <Img src={logo} alt="Minha Imagem" />
            <ButtonImg onClick={() => navigate("/")}>
              {t("voltar para tela inicial")}
            </ButtonImg>
          </DivImg>
        </Space>
        <LinhaVertical />
        <Space>
          <Title>{t("comment-seller")}</Title>
          <ButtonSelect onSelectChange={handleSelectChange} />

          <Formik
            initialValues={initialValues}
            validationSchema={
              selectedOption === 1
                ? registerValidationSellerPF
                : registerValidationSellerPJ
            }
            onSubmit={handleSubmit}
            enableReinitialize={true}
          >
            <Form>
              <TitleInput> {t("name")}</TitleInput>
              <Field
                type="text"
                name="business_name"
                render={({ field }: { field?: FieldInputProps<any> }) => (
                  <InputWithIcon
                    icon={<FaWpforms />}
                    iconSize="23px"
                    field={field}
                  />
                )}
              />

              {registerError.some(
                (error: any) => error.field === "business_name"
              ) ? (
                registerError
                  .filter((error: any) => error.field === "business_name")
                  .map((error: any, index: any) => (
                    <ErrorText key={index}>
                      <p>{error.msgs}</p>
                    </ErrorText>
                  ))
              ) : (
                <ErrorText>
                  <ErrorMessage name="business_name" />
                </ErrorText>
              )}

              <MarginBottom />
              {selectedOption === 1 && (
                <>
                  <TitleInput>CPF</TitleInput>
                  <Field
                    type="text"
                    name="document"
                    render={({ field }: { field?: FieldInputProps<any> }) => (
                      <MaskedInput
                        field={field}
                        icon={<FaRegAddressCard />}
                        mask="999.999.999-99"
                        iconSize="23px"
                        placeholder=""
                      />
                    )}
                  />

                  {registerError.some(
                    (error: any) => error.field === "document"
                  ) ? (
                    // Se houver um erro específico, exiba apenas o erro personalizado
                    registerError
                      .filter((error: any) => error.field === "document")
                      .map((error: any, index: any) => (
                        <ErrorText key={index}>
                          <p>{error.msgs}</p>
                        </ErrorText>
                      ))
                  ) : (
                    // Caso contrário, exiba o erro do Formik
                    <ErrorText>
                      <ErrorMessage name="document" />
                    </ErrorText>
                  )}

                  <MarginBottom />
                </>
              )}

              <MarginBottom />

              <TitleInput> {t("phone")}</TitleInput>
              <Field
                type="text"
                name="phone"
                render={({ field }: { field?: FieldInputProps<any> }) => (
                  <MaskedInput
                    field={field}
                    icon={<CiPhone />}
                    mask="(99) 99999-9999"
                    iconSize="23px"
                    placeholder=""
                  />
                )}
              />

              {registerError.some((error: any) => error.field === "phone") ? (
                // Se houver um erro específico, exiba apenas o erro personalizado
                registerError
                  .filter((error: any) => error.field === "phone")
                  .map((error: any, index: any) => (
                    <ErrorText key={index}>
                      <p>{error.msgs}</p>
                    </ErrorText>
                  ))
              ) : (
                // Caso contrário, exiba o erro do Formik
                <ErrorText>
                  <ErrorMessage name="phone" />
                </ErrorText>
              )}

              <MarginBottom />

              {selectedOption === 2 && (
                <>
                  <TitleInput>CNPJ</TitleInput>
                  <Field
                    type="text"
                    name="cnpj"
                    render={({ field }: { field?: FieldInputProps<any> }) => (
                      <MaskedInput
                        field={field}
                        icon={<FaRegAddressCard />}
                        mask="99.999.999/9999-99"
                        iconSize="23px"
                        placeholder=""
                      />
                    )}
                  />

                  {registerError.some(
                    (error: any) => error.field === "cnpj"
                  ) ? (
                    // Se houver um erro específico, exiba apenas o erro personalizado
                    registerError
                      .filter((error: any) => error.field === "cnpj")
                      .map((error: any, index: any) => (
                        <ErrorText key={index}>
                          <p>{error.msgs}</p>
                        </ErrorText>
                      ))
                  ) : (
                    // Caso contrário, exiba o erro do Formik
                    <ErrorText>
                      <ErrorMessage name="cnpj" />
                    </ErrorText>
                  )}
                </>
              )}

              <MarginBottom />

              {selectedOption === 2 && (
                <>
                  <TitleInput> {t("corporate-reason")}</TitleInput>
                  <Field
                    type="text"
                    name="corporate_name"
                    render={({ field }: { field?: FieldInputProps<any> }) => (
                      <InputWithIcon
                        icon={<MdCorporateFare />}
                        iconSize="23px"
                        field={field}
                      />
                    )}
                  />

                  {registerError.some(
                    (error: any) => error.field === "corporate_name"
                  ) ? (
                    // Se houver um erro específico, exiba apenas o erro personalizado
                    registerError
                      .filter((error: any) => error.field === "corporate_name")
                      .map((error: any, index: any) => (
                        <ErrorText key={index}>
                          <p>{error.msgs}</p>
                        </ErrorText>
                      ))
                  ) : (
                    // Caso contrário, exiba o erro do Formik
                    <ErrorText>
                      <ErrorMessage name="corporate_name" />
                    </ErrorText>
                  )}
                </>
              )}

              <MarginBottom />

              {selectedOption === 2 && (
                <>
                  <TitleInput> {t("state-registration")}</TitleInput>
                  <Field
                    type="number"
                    name="state_registration"
                    render={({ field }: { field?: FieldInputProps<any> }) => (
                      <InputWithIcon
                        icon={<MdCorporateFare />}
                        iconSize="23px"
                        field={field}
                        onChange={(e) => {
                          if (field) {
                            const numericValue = e.target.value.replace(
                              /\D/g,
                              ""
                            );
                            field.onChange({
                              target: { value: numericValue, name: field.name },
                            });
                          }
                        }}
                        onBlur={(e) => {
                          if (field) {
                            const numericValue = e.target.value.replace(
                              /\D/g,
                              ""
                            );
                            field.onChange({
                              target: { value: numericValue, name: field.name },
                            });
                          }
                        }}
                      />
                    )}
                  />

                  {registerError.some(
                    (error: any) => error.field === "state_registration"
                  ) ? (
                    // Se houver um erro específico, exiba apenas o erro personalizado
                    registerError
                      .filter(
                        (error: any) => error.field === "state_registration"
                      )
                      .map((error: any, index: any) => (
                        <ErrorText key={index}>
                          <p>{error.msgs}</p>
                        </ErrorText>
                      ))
                  ) : (
                    // Caso contrário, exiba o erro do Formik
                    <ErrorText>
                      <ErrorMessage name="state_registration" />
                    </ErrorText>
                  )}
                </>
              )}

              <MarginBottom />

              <TitleInput>{t("email")}</TitleInput>
              <Field
                type="text"
                name="email"
                render={({ field }: { field?: FieldInputProps<any> }) => (
                  <InputWithIcon
                    icon={<MdOutlineEmail />}
                    iconSize="23px"
                    field={field}
                  />
                )}
              />

              {registerError.some((error: any) => error.field === "email") ? (
                // Se houver um erro específico, exiba apenas o erro personalizado
                registerError
                  .filter((error: any) => error.field === "email")
                  .map((error: any, index: any) => (
                    <ErrorText key={index}>
                      <p>{error.msgs}</p>
                    </ErrorText>
                  ))
              ) : (
                // Caso contrário, exiba o erro do Formik
                <ErrorText>
                  <ErrorMessage name="email" />
                </ErrorText>
              )}

              <MarginBottom />
              <TitleInput>{t("password")}</TitleInput>
              <Field
                type="password"
                name="password"
                render={({ field }: { field: FieldInputProps<any> }) => (
                  <InputWithIcon
                    icon={<RiLockPasswordLine />}
                    iconSize="23px"
                    field={field}
                    type="password"
                  />
                )}
              />

              {registerError.some(
                (error: any) => error.field === "password"
              ) ? (
                registerError
                  .filter((error: any) => error.field === "password")
                  .map((error: any, index: any) => (
                    <ErrorText key={index}>
                      <p>{error.msgs}</p>
                    </ErrorText>
                  ))
              ) : (
                <ErrorText>
                  <ErrorMessage name="password" />
                </ErrorText>
              )}

              <MarginBottom />

              <TitleInput>{t("confirm-password")}</TitleInput>
              <Field
                type="text"
                name="confirm_password"
                render={({ field }: { field?: FieldInputProps<any> }) => (
                  <InputWithIcon
                    icon={<RiLockPasswordLine />}
                    iconSize="23px"
                    field={field}
                    type="password"
                  />
                )}
              />

              <ErrorText>
                <ErrorMessage name="confirm_password" />
              </ErrorText>

              <MarginBottom />

              <Center>
                <ButtonEnter type="submit">
                  {isLoading ? (
                    <BeatLoader className="spinner" size={8} color={"#fff"} />
                  ) : (
                    <TitleButtonEnter>{t("register")}</TitleButtonEnter>
                  )}
                </ButtonEnter>
              </Center>
            </Form>
          </Formik>
        </Space>
      </Content>
    </Container>
  );
}
